import React from 'react';
import { withProps } from 'recompose';
import { AdditionalFacilitiesIndicator } from 'components/search/AdditionalFacilitiesIndicator';

export default withProps(
	({ injectedComponents, lastInOriginalSearch, searchLocation }) => {
		if ((lastInOriginalSearch !== null) && (lastInOriginalSearch >= 0)) {
			const additionalPropertiesParams = <AdditionalFacilitiesIndicator location={searchLocation} />;
			return {
				injectedComponents: {
					...injectedComponents,
					[lastInOriginalSearch + 1]: additionalPropertiesParams
				}
			};
		}
		return {};
	}
);
